export default "__VITE_ASSET__CIATqWbE__"